<template>
    <div v-if="hasAccess">
        <top-nav-bar goto="/leaves">
            <router-link :to="{ name: 'leaves-edit', params: { leave: $route.params.leave }}" tag="button"
                         class="h-full items-center flex bg-secondary absolute pin-t pin-r mr-2 text-white font-bold font-heading uppercase"
                         v-if="leave && leave.status.value === 'rejected'">
                <i class="fas fa-pencil mr-2"></i>
                Edit
            </router-link>
        </top-nav-bar>

        <div v-if="leave" class="py-2 clearfix">
            <h3 class="text-center" v-text="leave.subtype.name"></h3>
            <h5 class="text-center" v-text="leave.type"></h5>

            <list>
                <list-item>
                    <template slot="icon">
                        <i class="fa fa-tasks text-blue w-6 h-6"></i>
                    </template>
                    <template slot="title">Current Status</template>
                    <template slot="sub-title">{{leave.status.status}}</template>
                </list-item>
                <list-item>
                    <template slot="icon">
                        <i class="fa fa-clock text-blue w-6 h-6"></i>
                    </template>
                    <template slot="title">Duration</template>
                    <template slot="sub-title">
                        {{formatDate(leave.start, 'D MMM YYYY')}}
                        {{leave.end ? `- ${formatDate(leave.end, 'D MMM YYYY')}` : '&rarr;'}}
                    </template>
                </list-item>
                <list-item v-if="leave.percentageReadable">
                    <template slot="icon">
                        <i class="fa fa-percentage text-blue w-6 h-6"></i>
                    </template>
                    <template slot="title">Percentage of Leave</template>
                    <template slot="sub-title">{{leave.percentageReadable}}</template>
                </list-item>
            </list>

            <list>
                <list-item v-for="(document, index) in leave.documents" :key="'document'+index">
                    <template slot="icon">
                        <i class="fa fa-file text-blue"></i>
                    </template>
                    <template slot="title">{{document.filename}}</template>
                    <template slot="sub-title">{{formatDate(document.created_at, 'D MMM YYYY HH:m')}}</template>
                    <template slot="actions">
                        <a class="btn btn--colored__blue w-full text-center" :href="document_url(document)" target="_blank">
                            <i class="far fa-eye"></i>
                        </a>
                    </template>
                </list-item>
            </list>

            <div class="bg-white mb-8">
                <h3 class="py-4 border-b border-grey-light flex items-center justify-center">
                    <span class="mr-2">Comments</span>
                    <button class="btn btn--sm btn--outline__green"
                            v-if="leave && leave.status.value !== 'approved'"
                            @click="addComment">
                        Add comment
                    </button>
                </h3>

                <div v-for="comment in sortedComments" :key="comment.id">
                    <div class="relative border-b border-grey-light px-4 pb-4">
                        <div class="flex items-center">
                            <div class="flex-1">
                                <h5>
                                    {{comment.creator.name}}
                                    <span class="font-normal rounded bg-grey-light p-1">
                                        {{comment.creator.type}}
                                    </span>
                                </h5>
                                <div v-if="comment.status" class="mt-4 flex items-center">
                                    <span class="text-xs p-1 bg-grey text-white rounded">
                                        <strong>Status:</strong> {{comment.status.status}}
                                    </span>
                                </div>
                            </div>
                            <div class="text-xs mr-4" v-text="ago(comment.created_at)"></div>
                        </div>
                        <div class="pt-4 text-sm" v-html="comment.body"></div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import InteractsWithDates from '@/mixins/InteractsWithDates';
    import CanAccessView from "../mixins/CanAccessView";
    import auth from '../auth';

    export default {

        mixins: [InteractsWithDates, CanAccessView],

        data() {
            return {
                leave: null,
            }
        },

        computed: {
            sortedComments() {
                return _.sortBy(this.leave.comments, function (comment) {
                    return comment.created_at;
                }).reverse();
            }
        },

        mounted() {
            this.$api('leave-tracker/pub').get(this.$route.params.leave)
                .then(({data}) => {
                    this.leave = data.data;
                });
        },

        methods: {
            document_url(document) {
                return `${process.env.VUE_APP_PORTAL}/crew-management/leave-tracker/documents/` +
                    `${document.id}?api_token=${auth.getToken()}&timestamp=${(new Date()).getTime()}`;
            },

            addComment() {
                if (this.leave && this.leave.status.value === 'approved') {
                    return false;
                }

                this.$swal({
                    title: 'Add a Comment',
                    input: 'textarea',
                    confirmButtonText: 'Save',
                    showCancelButton: true,
                }).then((body) => {
                    body && this.$api('leave-tracker/pub').post(`${this.$route.params.leave}/comments`, {body})
                        .then(({data}) => {
                            this.leave.comments.push(data.data);
                            this.$noty.success('The Comment was successfully saved');
                        })
                        .catch((error) => {
                            if (error.response.data.errors.errorMessage) {
                                this.$noty.error(error.response.data.errors.errorMessage[0]);
                            }
                        });
                }).catch(() => {
                    /* NOP */
                });
            },
        }
    }
</script>
